import React, { useEffect, useState } from 'react';
import { Col, Image, Row, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import camelCaseRecursive from 'camelcase-keys-recursive';
import { Icon } from '../..';
import LinkBtn from '../../Utils/Button/LinkBtn';
import { showEmployeeCardsRequest } from '../../../requests/vacations';
import ShowButtonBlack from '../../HRDashboardStyled/images/ShowButtonBlack.png';

const EmployeeData = ({ user }) => {
  const { advanceSettings } = useSelector(state => state.utils);
  const dispatch = useDispatch();
  const employee = user.employeeCard;
  const boss = user.directBoss;
  const { fileInfo = {} } = employee;
  const currentEmployee = employee.id;
  const [legalVacationCard, setLegalVacationCard] = useState({});
  const avalaibleVacations = legalVacationCard.vacationsAvailable;

  const vacationsRole = advanceSettings
    .filter(asItem => ['legal_holiday'].includes(asItem.code))
    .some(x => x.textValue === 'true');

  const vacationBalance = advanceSettings
    .filter(asItem => ['toggle_vacation_balance'].includes(asItem.code))
    .some(x => x.textValue === 'true');

  const handleSuccessShow = response => {
    const { data } = response;
    setLegalVacationCard(camelCaseRecursive(data.legal_vacation_card));
  };

  const fetchEmployeeCards = () => {
    if (currentEmployee) {
      showEmployeeCardsRequest({
        dispatch,
        params: {
          employee_id: currentEmployee
        },
        successCallback: handleSuccessShow
      });
    }
  };
  useEffect(fetchEmployeeCards, [currentEmployee]);

  const renderLine = (text, className = '') => {
    return (
      <p
        className={`mb-0 font-size-responsive position-top-box employee-edit-top-box ${className}`.trim()}
        style={{ fontSize: '11px' }}
      >
        {text}
      </p>
    );
  };

  return (
    <>
      <div
        id="HRDashboard"
        style={{
          backgroundColor: '#fff',
          border: '1px solid #E0E0E0',
          borderRadius: '8px',
          height: '100%'
        }}
      >
        <div
          style={{
            textAlign: 'center',
            backgroundColor: '#fff',
            borderTopRightRadius: 8,
            borderTopLeftRadius: 8
          }}
        >
          <Row>
            <Col className="mt-2" md={8} xl={8} xs={8}>
              <p
                style={{
                  fontSize: '12px',
                  fontWeight: 'bold',
                  color: '#827f7f',
                  textAlign: 'left',
                  marginLeft: '10px'
                }}
              >
                Mis Datos
              </p>
            </Col>
            <Col md={4} xl={4} xs={4} style={{ paddingRight: '30px' }}>
              <div className="DownloadButton">
                <LinkBtn to="/profile" variant="link" className="p-0" aria-label="Ver perfil">
                  <img src={ShowButtonBlack} alt="Ver perfil" />
                </LinkBtn>
              </div>
            </Col>
          </Row>
        </div>

        <div style={{ paddingRight: 15, paddingLeft: 15 }}>
          <Row className="align-items-center">
            {!currentEmployee ? (
              <Col className="div-content mt-5 mb-5">
                <div className="containerSpinnerLoadDash" style={{ position: 'absolute', height: '100%' }}>
                  <Spinner animation="border" variant="primary" />
                </div>
              </Col>
            ) : (
              <>
                <Col md={3} xs={12} xl={3} className="mb-2 mb-md-0">
                  <div className="d-flex align-items-center">
                    <div className="avatar employee d-flex align-items-center">
                      <div className={fileInfo.fileUrl ? 'content' : 'empty content'} style={{ width: 80, height: 80 }}>
                        {fileInfo.fileUrl ? (
                          <Image
                            src={fileInfo.fileUrl}
                            fluid
                            roundedCircle
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        ) : (
                          <Icon icon="camera" />
                        )}
                      </div>
                      <h3
                        className="show-mobile mb-1 ml-2"
                        style={{ fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                      >
                        {fileInfo.fullName}
                      </h3>
                    </div>
                  </div>
                </Col>
                <Col md={9} xs={12} xl={9} className="mb-2 mb-md-0">
                  <p className="mb-2 font-size-responsive" style={{ fontSize: '11px' }}>
                    {employee.fullName}
                  </p>
                  <Row>
                    <Col md={6} xs={12} xl={6} className="mb-2 mb-md-0">
                      {employee.jobTitle &&
                        renderLine(
                          employee.jobTitle.length > 25 ? `${employee.jobTitle.slice(0, 25)}...` : employee.jobTitle,
                          'mt-0'
                        )}
                      {employee.email && renderLine(employee.email, 'mt-2')}
                    </Col>
                    <Col md={6} xs={12} xl={6} className="mb-2 mb-md-0">
                      {boss && (
                        <p className="mb-0 mt-0" title="Jefe a Cargo" style={{ fontSize: '11px' }}>
                          <Icon icon="people" color="#F7F7F7" className="rounded-icon green icon-15 mr-2" />
                          {`${boss.name} ${boss.firstLastName}`}
                        </p>
                      )}
                      {vacationsRole && vacationBalance && (
                        <p className="text-orange mb-0 mt-2" style={{ fontSize: '11px' }}>
                          <Icon icon="calendar" color="#F7F7F7" className="rounded-icon orange icon-15 mr-2" />
                          Días acumulados: {avalaibleVacations || '0'}
                        </p>
                      )}
                    </Col>
                  </Row>
                </Col>
              </>
            )}
          </Row>
        </div>
      </div>
    </>
  );
};

export default EmployeeData;
